import { Field } from 'formik';

import { BaseCheckboxGroup } from '../BaseCheckboxGroup/BaseCheckboxGroup';

export const CheckboxGroupField = ({ name, label, options, value }) => (
  <Field
    component={BaseCheckboxGroup}
    name={name}
    label={label}
    options={options}
    value={value}
    data-testid={name}
  />
);

export default CheckboxGroupField;
